import { render, staticRenderFns } from "./M5.vue?vue&type=template&id=c0e1d5ba&scoped=true&"
import script from "./M5.vue?vue&type=script&lang=js&"
export * from "./M5.vue?vue&type=script&lang=js&"
import style0 from "./M5.vue?vue&type=style&index=0&id=c0e1d5ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e1d5ba",
  null
  
)

export default component.exports